module.exports = {
  schema: {
    name: '收支資料',
    type: 'Object',
    contents: {
      date: {
        type: 'Date',
        format: 'YYYY-MM-DD',
        name: '日期',
      },
      accountRef: {
        type: 'ObjectId',
        reference: 'accounts',
        refKeys: ['accountCode', 'account'],
        name: '科目代碼',
        input: 'select',
      },
      paymentMethodRef: {
        type: 'ObjectId',
        reference: 'paymentMethods',
        name: '收付方式',
        refKeys: ['paymentMethod'],
        input: 'select',
      },
      storeRef: {
        type: 'ObjectId',
        reference: 'stores',
        name: '店別',
        refKeys: ['name'],
        input: 'select',
      },
      amount: {
        type: 'Number',
        name: '金額',
      },
      cashflowDirection: {
        type: 'String',
        name: '收支類別',
        input: 'select',
        options: ['收入', '支出'],
      },
      detail: {
        type: 'String',
        name: '內容',
      },
      notice: {
        type: 'String',
        name: '備註',
      },
      supplierRef: {
        type: 'ObjectId',
        reference: 'suppliers',
        name: '供應商',
        refKeys: ['name'],
        input: 'select',
      },
      staffRef: {
        type: 'ObjectId',
        reference: 'staffers',
        refKeys: ['key'],
        name: '人員',
        input: 'select',
      },
      miscellaneousNum: {
        type: 'String',
        name: '其他收支編號',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'date', width: 100 },
        { key: 'accountRef', width: 180 },
        { key: 'paymentMethodRef', width: 160 },
        { key: 'storeRef', width: 140 },
        { key: 'amount', width: 70 },
        { key: 'cashflowDirection', width: 80 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '收支資料',
          rows: [
            [{ key: 'date' }],
            [{ key: 'storeRef' }, { key: 'accountRef' }, { key: 'paymentMethodRef' }],
            [{ key: 'cashflowDirection' }, { key: 'amount' }],
            [{ key: 'detail' }],
            [{ key: 'notice' }],
          ],
        },
        {
          name: '其他資料',
          rows: [
            [{ key: 'supplierRef' }],
            [{ key: 'staffRef' }],
            [{ key: 'miscellaneousNum' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/entries.js